import React, { ReactElement, useRef } from 'react';
import { InteractivityProps } from './Lottie.types';
import { useInitInteractivity } from './useInitInteractivity';

const useLottieInteractivity = ({
  actions,
  mode,
  lottieObj,
}: InteractivityProps): ReactElement => {
  const { animationItem, View } = lottieObj;

  const wrapperRef = useRef<HTMLDivElement>(null);
  useInitInteractivity({ actions, animationItem, mode, wrapperRef });

  return <div ref={wrapperRef}>{View}</div>;
};

export default useLottieInteractivity;
